import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { getSFCCRequestHeaders } from '../../../sfcc/utilities/get-sfcc-request-headers';
import { getFetchSFCCPricesUrlGetBySkus } from '../utilities/get-fetch-sfcc-prices-url-by-skus.get';
/**
 * @internal
 */
export var fetchPricesGetBySkus = function (productSkus) { return __awaiter(void 0, void 0, void 0, function () {
    var url, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFetchSFCCPricesUrlGetBySkus(productSkus);
                return [4 /*yield*/, getSFCCRequestHeaders()];
            case 1:
                requestOptions = _a.sent();
                return [4 /*yield*/, fetchGet(url, requestOptions)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
